import { createContext } from 'react';

const CreateEditClassContext = createContext({});

export default CreateEditClassContext;
